import React from 'react';
import { Heart, PawPrint, FileText, CheckCircle2 } from 'lucide-react';

export function VirtualAdoptionInfo() {
  return (
    <div className="space-y-8">
      {/* What is Virtual Adoption */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <Heart className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
          </div>
          <h2 className="card-title">
            Czym jest adopcja wirtualna?
          </h2>
        </div>
        
        <div className="space-y-4">
          <p className="body-medium">
            To jeden ze sposobów pomocy naszym zwierzakom. Jako wirtualny opiekun nie zabierzesz wprawdzie 
            podopiecznego do domu, ale możesz np. co miesiąc przekazywać na jego rzecz jakąś niewielką kwotę, 
            karmę, zabawki lub akcesoria, które są mu potrzebne.
          </p>
          <p className="body-medium">
            Dzięki temu polepszysz jego sytuację, zapewnisz rzeczy, na które przytulisko, być może, nie mogłoby 
            sobie pozwolić. Opieka wirtualna to dla nas duże odciążenie.
          </p>
          <p className="body-medium">
            Działa to tak, że pieniądze, które wydalibyśmy na Twojego wirtualnego podopiecznego będą mogły zostać 
            wydane na pozostałe zwierzaki, a zatem jako opiekun wybranego zwierzaka polepszasz też sytuację innych 
            psów i kotów.
          </p>
          <ul className="space-y-3 body-medium">
            <li className="list-item">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0" aria-hidden="true" />
              <span>Możesz przekazywać karmę i akcesoria</span>
            </li>
            <li className="list-item">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0" aria-hidden="true" />
              <span>Wspierasz finansowo w dowolnej kwocie</span>
            </li>
            <li className="list-item">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0" aria-hidden="true" />
              <span>Pomagasz nie tylko wybranemu zwierzakowi, ale całemu przytulisku</span>
            </li>
          </ul>
        </div>
      </div>

      {/* How to Become Virtual Guardian */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <PawPrint className="w-6 h-6 text-accessible-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-accessible-gray-900 dark:text-white high-contrast:text-white">
            Jak zgłosić chęć opieki?
          </h2>
        </div>
        
        <div className="space-y-4 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <p>
            Napisz maila pod adres <a href="mailto:znajdki2012@gmail.com" className="text-accessible-red-600 hover:text-accessible-red-700">znajdki2012@gmail.com</a> lub 
            wyślij wiadomość na profilu FB znajdki z informacją, którego zwierzaka wybrałeś i w jaki sposób zamierzasz mu pomagać.
          </p>
          <p>
            Następnie zapisz numer konta podany w zakładce KONTAKT i wpłać daną kwotę dla swojego podopiecznego. 
            W tytule wpłaty koniecznie napisz swoje imię lub nick (pojawi się w podziękowaniach) oraz imię zwierzaka!
          </p>
        </div>
      </div>
      
      {/* Cost Information */}
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
            <FileText className="w-6 h-6 text-accessible-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-accessible-gray-900 dark:text-white high-contrast:text-white">
            Ile kosztuje opieka wirtualna?
          </h2>
        </div>
        
        <div className="space-y-4 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <p>
            Nie określamy, jaką kwotę należy wpłacać. Łatwo policzyć jaki jest miesięczny koszt utrzymania zwierzaka 
            lub ile karmy potrzeba dla każdego z nich, ale nie oczekujemy, że wirtualni opiekunowie pokryją wszystkie koszta.
          </p>
          <p>
            Każda wpłacona złotówka jest dla nas na wagę złota. Ziarnko do ziarnka...
          </p>
        </div>
      </div>
    </div>
  );
}